export default class DtoHydrometrySituation {
    constructor(obj = {}) {
        this.hydrometricStationId = obj.hydrometricStationId
        this.stationId = obj.hydrometricStationId
        this.measures = obj.measures
    }
}